const NS = 'SliderBlock';
const CLS = 'sliderBlock';

import { fullWindowHeightMixinBlock } from '../../mixins/fullWindowHeightMixinBlock/fullWindowHeightMixinBlock';

export class SliderBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$slider = this.$element.find(`.${CLS}-slider`);
		this.$sliderInput = this.$element.find(`.${CLS}-slider-input input`);
		this.$radios = this.$element.find(`.${CLS}-radio`);
		this.$tracker = $('[data-pg][data-tracker="true"]');
		this.trackingId = this.$element.data('trackingId');

		if(this.hasTrackingId()) {
			if(!this.hasTracker()) {
				console.error(`${NS}::Error`, 'Please ensure that the "[data-pg][data-tracker="true"]" element exists.');
				return;
			}
		}

		let ticks = [];
		let ticksLabels = [];

		this.$radios.each((index, element) => {
			ticks.push($(element).val());
			ticksLabels.push($(element).attr('data-label'));
		});

		this.$sliderInput.slider({
			ticks: ticks,
			ticks_labels: ticksLabels,
			value: ticks[0],
			ticks_snap_bounds: 30
		});

		// Slider change if any
		this.$sliderInput.on('change', (sliderElement) => {
			let value = sliderElement.value.newValue;

			this.$radios.each((index, element) => {
				if(+$(element).attr('data-value') === value) {
					$(element).prop('checked', true);
					$(element).trigger('change');

					this.updateTrackingCompleteStatus();
				}
			});
		});

		// Radio change event if any
		this.$radios.each((index, element) => {
			$(element).on('change', () => {
				this.$sliderInput.slider().data('slider').setValue(+$(element).attr('data-value'));
			});
		});

		this.$slider.css({ visibility: 'visible' });
		this.initFullWindowHeight(this);

		// Initial change trigger for slider to render
		setTimeout(() => {
			this.$sliderInput.slider('refresh');
		}, 250);
	}

	hasTrackingId() {
		return !_.isNil(this.trackingId) && this.trackingId !== '';
	}

	hasTracker() {
		return this.$tracker && this.$tracker.length > 0;
	}

	updateTrackingCompleteStatus() {
		if(this.hasTrackingId() && this.hasTracker()) {
			if(!this.$element.data('trackingComplete')) {
				this.$tracker.trigger('tracking.complete', { $element: this.$element, trackingId: this.trackingId } );
				this.$element.attr('data-tracking-complete', true);
			}
		}
	}
}

Object.assign(SliderBlock.prototype, fullWindowHeightMixinBlock);
